import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Observable, of, throwError, Subject, BehaviorSubject } from "rxjs"
import { catchError, map } from "rxjs/operators"
import { environment } from 'src/environments/environment';
export interface Chat {
  audio_url?: string;
  sessionId: string;
  query: string
  response: string
  audioUrl?: string
  cached: boolean
  _id: string
  timestamp: string
  updatedAt: string
}
export interface AudioGenerationResponse {
  audioUrl: string
}
export interface ChatMessage {
  sessionId: any;
  // sessionId: boolean;
  //  sessionId: boolean;
  content: any
  sender: "user" | "ai"
  timestamp: Date
  audioUrl?: any
  Text: string
}
export interface ChatSession {
  id: any;
  showMenu: boolean;
  editing: boolean;
  category: any;
  sessionId: string | null;
  chats: never[];
  _id: string
  userId: string
  sessionName: string
  messages?: Array<{
    role: "user" | "assistant"
    content: string
    timestamp: string
  }>
  createdAt: string
  updatedAt: string
}

interface ApiResponse {
  audio_url: any;
  response: string
}


@Injectable({
  providedIn: 'root'
})
// http://127.0.0.1:8000/api/chat-history/
export class ChatService {
  private chatUpdated = new Subject<void>();
  //  private apiUrl = "http://127.0.0.1:8000/"
  //  private apiUrl = "https://api.scholarx.irishtaylor.dev/"
  private apiUrl = environment.pythonApiUrl;
  private userId = "6788ec615aa6f353519cae77"
  private currentChatSubject = new BehaviorSubject<ChatSession | null>(null);
  private audioGenerationUrl = "http://127.0.0.1:8000/api/audio-generate-gtts/"
  constructor(private http: HttpClient) { }
  sendMessage(payload: any): Observable<ChatMessage> {
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('No token found in localStorage');
      return throwError(() => new Error('Authentication token missing'));
    }

    const headers = new HttpHeaders({
      'Authorization': `Token ${token}`,
      'Content-Type': 'application/json'
    });

    console.log("Sending Request Headers:", headers.get('Authorization'));

    return this.http.post<ApiResponse>(this.apiUrl + `/api/query_collection_new/`, payload, { headers }) // ✅ Pass headers
      .pipe(
        map((response: any) => {
          const chatMessage: ChatMessage = {
            content: response.answer,
            Text: response.response,
            sender: "ai",
            timestamp: new Date(),
            audioUrl: response.audio_url,
            sessionId: undefined
          };

          // ✅ Store sessionId if returned from the API
          if (response.sessionId) {
            chatMessage.sessionId = response.sessionId;
          }

          return chatMessage;
        }),
        catchError((error) => {
          console.error('Error sending message:', error);
          // return throwError(() => new Error('Failed to send message'));
          return throwError(() => error);
        })
      );
  }




  // getChatHistory(userId: string): Observable<ChatHistoryItem[]> {
  //   return this.http.get<ChatHistoryItem[]>(`${this.apiUrl+'api/chat-history/'}?userId=${userId}`)
  // }
  getChatHistory(pageNumber: any, userId: any, sessionId: any): Observable<ChatSession[]> {
    const payload = {
      userId: userId,
      sessionId: sessionId,
      page: pageNumber,
      refresh: true
    };

    return this.http.post<ChatSession[]>(`${this.apiUrl}/api/chat-history/`, payload);
  }

  // generateAudio(text: string): Observable<AudioGenerationResponse> {
  //   const headers = new HttpHeaders({
  //     "Content-Type": "application/json",
  //   })
  //   return this.http.post<AudioGenerationResponse>(this.audioGenerationUrl, { text }, { headers })
  // }
  getAudioStream(text: string): Observable<string> {
    const headers = new HttpHeaders({ "Content-Type": "application/json" })

    return this.http
      .post<{ audioUrl: string }>(this.audioGenerationUrl, { text }, { headers })
      .pipe(map((response) => response.audioUrl))
  }
  getAudio(text: any): Promise<string | null> {  // Ensure it returns a promise with audio URL
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post(this.audioGenerationUrl, { text }, { headers, responseType: 'blob' })
      .toPromise()
      .then((blob: Blob | undefined) => {
        if (blob) {
          const audioUrl = URL.createObjectURL(blob);
          return audioUrl; // Return the generated audio URL
        } else {
          console.error('No audio returned.');
          return null;
        }
      })
      .catch(error => {
        console.error('Audio fetch failed:', error);
        return null;
      });
  }

  notifyChatUpdated() {
    this.chatUpdated.next();
  }

  // http://127.0.0.1:8000/api/pin-session/

  // payload

  // {
  //   "sessionId": "9e86daae-854f-4fdc-a406-353f0f73bad0",
  //   "pinned": true
  // }
  pinSession(sessionId: any, pinned: boolean) {
    const payload = { sessionId, pinned };
    return this.http.put(`${this.apiUrl}/api/pin-session/`, payload);

  }
  getPinnedSessions(userId: string, page: number = 1, size: number = 5): Observable<any> {
    const params = {
      userId,
      page: page.toString(),
      size: size.toString()
    };

    return this.http.get<any>(`${this.apiUrl}/api/get-pinned-sessions/`, { params });
  }

  renameSession(userId: string, sessionId: string, newName: string) {
    const payload = {
      userId,
      sessionId,
      action: 'rename',
      newName
    };

    return this.http.patch(`${this.apiUrl}/update-chat-session/`, payload);
  }
  searchChat(payload: any): Observable<any> {
    // const body = { query };
    return this.http.post<any>(`${this.apiUrl}/chat-search/`, payload);
  }
  deleteSession(userId: string, sessionId: string) {
    const url = `${this.apiUrl}/update-chat-session/`; // Update if endpoint is different
    const body = {
      userId,
      sessionId,
      action: 'delete'
    };

    return this.http.patch(url, body);
  }

  private refreshSidebarSource = new Subject<void>();
  refreshSidebar$ = this.refreshSidebarSource.asObservable();

  triggerRefresh() {
    this.refreshSidebarSource.next();
  }


  currentChat$ = this.currentChatSubject.asObservable();

  // Call this to set a chat (history click)
  setCurrentChat(chat: ChatSession | null) {
    this.currentChatSubject.next(chat);
  }
}

